window.App = window.App || {}
window.App.NotificationService = (function(){
  var getUserName = function() {
    return $.cookie('user_name');
  }
  var tokenStorageKeyName = getUserName() + '_fbToken';
  // Do not change this value in any conditions.
  var ntfSendToServer = 'ntfSendToServer';
  var tokenAcquired = 'fb_token_acquired';

  function storeToken(token) {
      return window.localStorage && window.localStorage.setItem(tokenStorageKeyName, token);
  }

  function retrieveToken(token) {
      return window.localStorage && window.localStorage.getItem(tokenStorageKeyName);
  }

  function isTokenSentToServer() {
      return (window.localStorage && window.localStorage.getItem(ntfSendToServer) == 1) || Cookies.get(tokenAcquired) != null
  }

  function setTokenSentToServer(sent) {
      return window.localStorage && window.localStorage.setItem(ntfSendToServer, sent ? 1 : 0);
  }

  function setTokenAcquiredCookie(){
    return Cookies.set(tokenAcquired, 1, { domain: 'catawiki.' + document.location.origin.split('.')[2], expires: 365*100 })
  }

  function sendTokenToServer(url, data, onSuccess) {
      if (!isTokenSentToServer()) {
          // Send the current token to your server.
          var csrf_token = $('meta[name=csrf-token]');

          $.ajax({
              method: 'POST',
              url: url,
              crossDomain: true,
              xhrFields : {withCredentials: true},
              beforeSend: function(xhr) {
                if(csrf_token != null) {
                  xhr.setRequestHeader('X-CSRF-Token', csrf_token.attr('content'))
                }
              },
              data: data
          }).done(function(){
            setTokenSentToServer(true);
            setTokenAcquiredCookie();
            if(onSuccess != 'undefined' && typeof(onSuccess) == 'function') {
              onSuccess.apply(this);
            }
          }).fail(function(){
            setTokenSentToServer(false);
          })
      } else {
          console.log('Token already sent to server so won\'t send it again ' +
              'unless it changes');
      }
  }

  return {
    RetrieveToken: retrieveToken,
    StoreToken: storeToken,
    IsTokenSentToServer: isTokenSentToServer,
    SetTokenAcquiredCookie: setTokenAcquiredCookie,
    SetTokenSentToServer: setTokenSentToServer,
    SendTokenToServer: sendTokenToServer
  }
})();

window.App.NotificationService.WebNotificationOutBidPremissionWidget = {
  data: {
    $confirmModal: $('#cw_modal_confirmdialog'),
    className: 'confirmdialog-v4',
    image: {
      id: 'cw_web_notification_banner',
      url: '/images/v3/web_notification.png',
      width: 400,
      parent: '.cw-modal-content'
    },
    content: {
      title: TRANSLATIONS['coming_soon'] || 'Coming up soon: outbid notification on your desktop!',
      text: TRANSLATIONS['new_outbid_notification'] || "Know instantly when you have been outbid."
    },
    buttons: {
      yes_key: 'yes_im_interested',
      no_key: 'no_im_not_interested'
    }
  },
  modal: function(){
    var that = this;
    var data = that.data;
    var $confirmModalImg = $('<img />').attr({
      'id': data.image.id,
      'src': data.image.url,
      'width': data.image.width
    });
    that.reset();
    data.$confirmModal.addClass(data.className);
    data.$confirmModal.find(data.image.parent).prepend($confirmModalImg);
    cw_show_confirm_custom_btns('',
      '<h2>' + data.content.title + '</h2>' + data.content.text.replace(/(?:\r\n|\r|\n)/g, '<br />'),
      function(response){
        if(response.confirmed){
           ga_set_custom_dimension(71, 'approved');
           window.App.NotificationService.RequestPermission();
        }else{
          ga_set_custom_dimension(71, 'declined');
        }
        window.localStorage && window.localStorage.setItem("request_permission_widget", 1);
        that.reset();
      },
      data.buttons.yes_key,
      data.buttons.no_key
    );
  },
  reset: function(){
    var data = this.data;
    data.$confirmModal.removeClass(data.className);
    data.$confirmModal.find('#' + data.image.id).remove();
  }
}
